import Tab from './ui';

export {
	TabProvider,
	type TabProviderProps,
	useIsTabOverflowing,
	useIsTabSelected,
	useTabId,
} from './common/utils/tab-context';

export default Tab;
